import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import Toggle from 'react-toggle';
import Dropdown from 'app/components/Dropdown';
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import Checkbox from 'app/components/checkbox';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateDefaultTier from './useCreateDefaultTier';

const CreateDefaultTier = () => {
  const {
    handleChange,
    values,
    error,
    handleCreateDefaultTier,
    pageLoading,
    hideFields,
    mallList,
    masterList,
    setChange,
    supportId,
    navigate,
    handleCheckChange,
  } = useCreateDefaultTier();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${supportId ? 'Edit Default Tier' : 'Create Default Tier'}`}
          goTo={APP_CONSTANTS.TIER}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mallId'}
              label='Mall List*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={values?.mallId}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.mallId}
              isDisabled={supportId ? true : false}
            />
          </div>
          <div className='wd-100'>
            <div className='d-flex'>
              {masterList?.map((item, index) => {
                return (
                  <Checkbox
                    id={item?.id}
                    label={item?.name}
                    checked={item?.checked}
                    onChange={handleCheckChange}
                    disabled={supportId ? true : false}
                  />
                );
              })}
            </div>
            <div>
              {error.tierId && (
                <p className='loginWrapper-valid-text'>{error.tierId}</p>
              )}
            </div>
          </div>

          <div className='wd-50'>
            <NumberInput
              label='Percentage points* (%)'
              id='discount'
              placeholder='Discount'
              name='discount'
              value={values?.discount}
              errorText={error?.discount}
              max={100}
              onChange={handleChange}
              takeDecimal={true}
            />
          </div>

          <div className='wd-50'>
            <Dropdown
              id={'priority'}
              label='Priority*'
              name='priority'
              options={[
                { label: 1, value: 1 },
                { label: 2, value: 2 },
                { label: 3, value: 3 },
              ]}
              placeholder='Select Priority'
              value={values?.priority}
              handleChange={handleChange}
              errorText={error?.priority}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Min Range* (Rs)'
              id='minRange'
              placeholder='Min Range'
              name='minRange'
              value={values?.minRange}
              errorText={error?.minRange}
              onChange={handleChange}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Max range* (Rs)'
              id='maxRange'
              placeholder='Max range'
              name='maxRange'
              value={values?.maxRange}
              errorText={error?.maxRange}
              onChange={handleChange}
            />
          </div>

          <div className='wd-100'>
            <div className='d-block my-4'>
              <label className='me-2 d-inline-block tooltip-on-hover'>
                Status*
              </label>
              <label className='d-inline-block mt-2'>
                <div className='d-inline-flex align-items-center'>
                  <div className='d-inline-flex text-danger'>OFF</div>
                  <div className='d-inline-flex mx-2'>
                    <Toggle
                      checked={values.status}
                      icons={false}
                      onChange={() => setChange('status', !values.status)}
                    />
                  </div>
                  <div className='d-inline-flex text-green'>ON</div>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateDefaultTier}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateDefaultTier;
